import React from 'react';
import { type NotificationsSettings } from '../../api/types.js';
import { InputField } from './Field.js';
import ToggleRow from './ToggleRow.js';
import SaveBar from './SaveBar.js';
import { useEditable } from './useEditable.js';
import { useTranslation } from '../../i18n/useTranslation.js';

interface Props {
  value: NotificationsSettings;
  onSave: (next: NotificationsSettings) => Promise<void>;
}

function NotificationsTab({ value, onSave }: Props) {
  const { t } = useTranslation();
  const { draft, setNested, dirty, saving, reset, save } = useEditable(value, onSave);
  const c = draft.channels;
  const e = draft.endpoints;

  return (
    <div className="sp on">
      <div className="sp-title">{t('notifications.title')}</div>
      <div className="sp-subtitle">{t('notifications.subtitle')}</div>

      <div className="sg">
        <div className="sg-title">{t('notifications.alertDelivery')}</div>
        <ToggleRow
          label={t('notifications.dashboardToast')}
          sub={t('notifications.dashboardToastSub')}
          checked={c.dashboardToast}
          onChange={(v) => setNested('channels', { dashboardToast: v })}
          disabled // TODO:
        />
        <ToggleRow
          label={t('notifications.emailCritical')}
          sub={t('notifications.emailCriticalSub')}
          checked={c.emailCritical}
          onChange={(v) => setNested('channels', { emailCritical: v })}
          disabled // TODO:
        />
        <ToggleRow
          label={t('notifications.sms')}
          sub={t('notifications.smsSub')}
          checked={c.sms}
          onChange={(v) => setNested('channels', { sms: v })}
          disabled // TODO:
        />
        <ToggleRow
          label={t('notifications.webhook')}
          sub={t('notifications.webhookSub')}
          checked={c.webhook}
          onChange={(v) => setNested('channels', { webhook: v })}
          disabled // TODO:
        />
        <ToggleRow
          label={t('notifications.audioAlarm')}
          sub={t('notifications.audioAlarmSub')}
          checked={c.audioAlarm}
          onChange={(v) => setNested('channels', { audioAlarm: v })}
          disabled // TODO:
        />
      </div>

      <div className="sg">
        <div className="sg-title">{t('notifications.deliveryEndpoints')}</div>
        <div className="sg-grid one">
          <InputField
            label={t('notifications.alertEmail')}
            type="email"
            value={e.alertEmail}
            onChange={(v) => setNested('endpoints', { alertEmail: v })}
            readOnly // TODO:
          />
          <InputField
            label={t('notifications.smsNumber')}
            type="tel"
            value={e.smsNumber}
            onChange={(v) => setNested('endpoints', { smsNumber: v })}
            readOnly // TODO:
          />
          <InputField
            label={t('notifications.webhookUrl')}
            value={e.webhookUrl}
            hint={t('notifications.webhookHint')}
            onChange={(v) => setNested('endpoints', { webhookUrl: v })}
            readOnly // TODO:
          />
        </div>
      </div>

      <SaveBar dirty={dirty} saving={saving} onCancel={reset} onSave={save} />
    </div>
  );
}

export default NotificationsTab;
